import React from 'react';
import { Link } from 'react-router-dom';

const IntegrationPlatformPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Integration Platform</h1>
      <p className="text-xl mb-8">
        Connect and streamline your systems with our powerful integration platform. 
        Build seamless workflows and automate data exchange across your entire tech stack.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4">Key Features</h2>
          <ul className="space-y-3 text-gray-700">
            <li>• Pre-built connectors for popular systems</li>
            <li>• Custom API integration capabilities</li>
            <li>• Real-time data synchronization</li>
            <li>• Secure data transfer protocols</li>
            <li>• Visual workflow builder</li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4">Benefits</h2>
          <ul className="space-y-3 text-gray-700">
            <li>• Reduce manual data entry</li>
            <li>• Eliminate data silos</li>
            <li>• Improve data accuracy</li>
            <li>• Accelerate business processes</li>
            <li>• Scale operations efficiently</li>
          </ul>
        </div>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg text-center">
        <h2 className="text-2xl font-semibold mb-4">Ready to Get Started?</h2>
        <p className="mb-6 text-gray-700">
          Contact our team to learn how our Integration Platform can transform your business operations.
        </p>
        <Link
          to="/contact"
          className="bg-custom-blue text-white px-8 py-3 rounded-lg hover:bg-opacity-90 transition-colors"
        >
          Schedule a Demo
        </Link>
      </div>
    </div>
  );
};

export default IntegrationPlatformPage; 